import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import Bao from "./../../services/bao-service";
import * as $ from "jquery";
import * as ko from "knockout";
import BaoDialog from "./../../factories/bao-dialog";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
class WorkplaceQualification extends GenericListSearchTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.Models.subscribe(() => this.Selection([]));
    }
    SearchType(): string { return 'Qualification'; }
    ItemCompleteCheck(item): JQueryPromise<boolean> {
        const def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
    CustomFilter(): Models.HashObject[] { return null; }
    ToolbarClick = (button: Interfaces.Bao.BaoMenuItem) => this.CustomToolbarClick(button);
}
export default WorkplaceQualification;